import React from 'react'
import Dashboard from '../../dashboard/index'
import ListView from './page'

const List = () => {
  return <Dashboard component={<ListView />} />
}

export default List
